<template>
  <div id="chart-card-title">
    <v-card-title class="align-end fill-height" color="indigo">
      {{ title }}
      <v-spacer></v-spacer>
      <v-icon
        v-if="redirectEnabled"
        @click="redirectToChosenCost"
      >
        fas fa-pencil-alt
      </v-icon>
    </v-card-title>
  </div>
</template>

<script>

export default {
  name: 'chart-card-title',
  props: {
    color: {
      type: String,
      default: 'blue',
    },
    height: {
      type: String,
      default: '50px',
    },
    index: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      required: true,
    },
    redirectEnabled: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    redirectToChosenCost() {
      this.$router.push({
        name: 'calculator',
        query: {
          activeStep: this.index + 1,
        }
      });
    },
  },
};
</script>